import SearchModel from'./SearchModel';
class PersonModel {

    id = -1
    lastName = ""
    firstName = ""
    middleName = ""
    bDate = ""
    bLocation = ""
    citizen = ""
    nationality = ""
    criminal = ""
    nikName = ""
    desc = ""
    info = "" 
    
    searchModel = null;
}

export default PersonModel